export const COMPANY_INFO_ADD_PEOPLE_DIALOG = 'COMPANY_INFO_ADD_PEOPLE_DIALOG';
